class PeopleSingle {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let peopleTl = gsap.timeline();

    peopleTl.to('.js-img', 0.75, {
      clipPath: "inset(0% 0% 0% 0%)",
      delay: 0.3,
      onComplete: function(self) {
        $('.js-ttl').addClass('is-inview');
      }
    })

    peopleTl.to('.js-scroll, .js-subttl, .js-drawer, .js-header', 0.25, {
      opacity: 1,
      delay: 1,
      onStart: function() {
        $('.js-lineTxt').addClass('is-inview');
      }
    })
  }
}
